import { throwError } from "@/lib/throwError";
import { get, post } from "@/services/axiosUitils";
import { ManageActiveRecordParams } from "@/utils/types/activeRecord";

const basePath = "/dropdown/";

class DropdownService {
  getDropdownData = async (name: string, params?: any): Promise<any> => {
    if (!name) {
      throwError("Name is required", "DropdownService");
    }
    return await get(`${basePath}${name}/`, { params });
  };

  manageActiveRecord = async (
    params: ManageActiveRecordParams
  ): Promise<any> => {
    if (!params.table) {
      throwError("Table is required", "DropdownService");
    }
    if (!params.pk) {
      throwError("Primary key (pk) is required", "DropdownService");
    }
    if (typeof params.is_active !== "boolean") {
      throwError("is_active must be a boolean", "DropdownService");
    }
    return await post(`${basePath}manage-active-record/`, params);
  };

  /**
   * Get Users for dropdown
   */
  getUsers = async (): Promise<any[]> => {
    const data = await get(`${basePath}user/`);
    // Assuming the API returns a list or a results object
    if (Array.isArray(data)) {
      return data;
    } else if (data?.results && Array.isArray(data.results)) {
      return data.results;
    } else if (data?.data && Array.isArray(data.data)) {
      return data.data; // Some APIs wrap in 'data'
    }
    return [];
  };
}

export default new DropdownService();
